import nepal from '../assets/images/nepal.jpg';
import thailand from '../assets/images/thailand.jpg';
import maldives from '../assets/images/maldives.jpg';
import bali from '../assets/images/bali.jpg';
import singapore from '../assets/images/singapore.jpg';
import Manali from '../assets/images/manali.jpg'

const destinations = [
  { title: 'Nepal', image: nepal, listing: 18 },
  { title: 'Thailand', image: thailand, listing: 27 },
  { title: 'Maldives', image: maldives, listing: 22 },
  { title: 'Bali', image: bali, listing: 15 },
  { title: 'Singapore', image: singapore, listing: 11 },
    { title: 'Manali', image: Manali, listing: 11 }
];

export default destinations;